import { FormState } from "@/app/features/shared/form-builder/types/types";

export const defaultFormState: FormState = {
    isValid: false,
    isSubmitting: false,
    fieldErrors: null,
    error: null,
    message: null,
    success: null
}
